{
  "version": 1,
  "asset_id": "ba3eff44-0ef6-468b-a6fb-4bd6276da743",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/ba3eff44-0ef6-468b-a6fb-4bd6276da743/sleeve-ugi-reflux-post-800-es.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/ba3eff44-0ef6-468b-a6fb-4bd6276da743/sleeve-ugi-reflux-post-800-es.jpg",
  "original_filename": "sleeve-ugi-reflux-post-800-es.jpg",
  "size": 83843,
  "content_type": "image/jpeg",
  "created_at": "2026-09-28T16:44:18Z"
}
